<template>
	<router-view ref="child" />
</template>
<script>
export default {
	name: 'App',
	created(){
		if (process.env.NODE_ENV === 'production') {
			this.$nextTick(() => {
				// 1.禁用右键菜单
				document.oncontextmenu = new Function("event.returnValue=false");
				// 2.禁用鼠标选中
				// document.onselectstart = new Function("event.returnValue=false");
				// 3.禁止键盘F12键
				document.addEventListener("keydown", function (e) {
					// console.log(e)
					if (e.key == "F12") {
						e.preventDefault(); // 如果按下键F12,阻止事件
					}
				});
			});
		}
	}
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue